import { render } from "./nq-orientation.vue?vue&type=template&id=5a820da7&scoped=true"
import script from "./nq-orientation.vue?vue&type=script&lang=js"
export * from "./nq-orientation.vue?vue&type=script&lang=js"

import "./nq-orientation.vue?vue&type=style&index=0&id=5a820da7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a820da7"]])

export default __exports__